import { EditionStatus } from "../types";

export const deriveEditionStatus = (
  startDate?: number,
  endDate?: number,
): EditionStatus => {
  const now = Date.now();
  if (startDate && now < startDate) return "planned";
  if (endDate && now > endDate) return "ended";
  return "in-progress";
};

export const EDITION_STATUS_VARIANT: Record<
  EditionStatus,
  "info" | "success" | "default"
> = {
  planned: "default",
  "in-progress": "info",
  ended: "success",
};
